
















import { Vue, Component, Prop } from "vue-property-decorator"; // eslint-disable-line no-unused-vars
import { mapGetters } from "vuex";
import CdkImagePlaceholder from "./CdkImagePlaceholder.vue";

interface EncodedImage {
  thumbnail?: string;
  preview?: string;
}

@Component({
  components: {
    CdkImagePlaceholder
  },
  computed: {
    ...mapGetters("newsItems", ["getEncodedImageById"])
  }
})
export default class CdkImage extends Vue {
  @Prop({ required: false, default: false }) isCompact!: boolean;

  @Prop({ required: false, default: false }) isStandard!: boolean;

  @Prop({ required: true }) guid!: string;

  @Prop({ required: false, default: "square" }) layoutOrientation!: string;

  getEncodedImageById: (guid: string) => EncodedImage | undefined;

  get encodedImage(): string {
    const image = this.getEncodedImageById(this.guid);
    const key = this.isCompact ? "thumbnail" : "preview";
    return (image && image[key]) || "";
  }

  get imgSrc(): string {
    return `data:image/jpeg;base64,${this.encodedImage}`;
  }

  /**
   * Returns a string representing the image ratio
   */
  get ratio(): "horizontal" | "vertical" | "square" {
    if (this.layoutOrientation !== null) {
      const arr = this.layoutOrientation.split("/");

      return arr[arr.length - 1] as "horizontal" | "vertical" | "square";
    }

    return "square";
  }

  /**
   * Returns the width of the image placeholder for both views
   */

  getImageWidthByHeight(height: number) {
    if (this.ratio === "horizontal") {
      return (height / 2) * 3;
    }
    if (this.ratio === "vertical") {
      return (height / 3) * 2;
    }
    return height;
  }

  get compactWidth(): Number {
    return this.getImageWidthByHeight(24);
  }

  get standardWidth(): Number {
    return this.getImageWidthByHeight(160);
  }

  /**
   * Returns a style object for the width
   */
  get style(): any {
    if (this.isCompact) {
      return {
        width: `${this.compactWidth}px`
      };
    }
    if (this.isStandard) {
      return {
        width: `${this.standardWidth}px`
      };
    }
    return {};
  }
}
